function n(n){return null==n?[]:[].concat(n)}export{n as default};
//# sourceMappingURL=toArray.js.map
